import React from 'react';
import classNames from 'classnames';

import css from './LayoutWrapperFooter.css';

const LayoutWrapperFooter = props => {
  const { className, rootClassName, children } = props;
  const classes = classNames(rootClassName || css.root, className);

  return <div className={classes}>{children}</div>;
};

export default LayoutWrapperFooter;
